import io from "socket.io-client";

export const socket = io(`https://jaiaunoback.onrender.com`);
socket.on("connect", () => {
  console.log("connected");
});
